<template>
  <Appendix
    title="Phụ lục bảo hành"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      <div>
        <span
          >Lý do bàn giao:
          {{ item.appendixWarranty.warrantyReason | transformData(Config.reasonHandOver) }}
          {{ item.appendixWarranty.warrantyReason }}
          {{ item.appendixWarranty.receiverHandover }}</span
        >
      </div>
      <DeviceInfoAppendix
        :items="item.appendixWarranty.devices"
        :warrantyFee="true"
        :fields="deviceFields"
      >
      </DeviceInfoAppendix>
      <AttachedApendix
        v-if="
          item.appendixWarranty.appendixHandoverCode &&
          item.appendixWarranty.receiverHandover !== 'MERCHANT'
        "
        :items="[item.appendixWarranty]"
        :fields="fieldsTableAttached"
      />
    </template>
    <template #file="item">
      <div v-if="item.urlPDF" class="form-detail">
        <UploadMultiple
          :lsData="[item]"
          keyUrl="urlPDF"
          :canUpload="false"
          :title="`File phụ lục ${item.code}`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
    </template>
  </Appendix>
</template>

<script>
  import Config from '@/thirdParty/config'
  import AttachedApendix from './AttachedApendix.vue'
  import Appendix from './Appendix.vue'
  import DeviceInfoAppendix from './DeviceInfoAppendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, DeviceInfoAppendix, UploadMultiple, AttachedApendix },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Mã phụ lục', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'numDevices', label: 'SL thiết bị', class: 'text-right' },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
        fieldsTableAttached: [
          { key: 'attachApendix', label: 'BBBH đính kèm' },
          { key: 'appendixHandoverCode', label: 'Mã BBBG' },
          { key: 'status', label: 'Trạng thái BBBG', class: 'text-center' },
        ],
        deviceFields: [
          { key: 'displayName', label: 'Tên thiết bị', class: 'text-left' },
          { key: 'serialNumber', label: 'Mã serial', class: 'text-left' },
          { key: 'handoverDevice', label: 'Bàn giao thay cho TB', class: 'text-left' },
          {
            key: 'price',
            label: 'Phí BH',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
        ],
        Config,
      }
    },
  }
</script>

<style scoped></style>
